/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubmissionPayloadDto
 */
export interface UpdateSubmissionPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    assignedHandlerId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    namedUnderwriterId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    originalCurrency: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateSubmissionPayloadDto
     */
    inceptionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateSubmissionPayloadDto
     */
    expiryDate: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    principalOccupation: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    mainRegionAndRiskTerritory: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    keyRiskLocation: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    subClass: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionPayloadDto
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSubmissionPayloadDto
     */
    fileIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateSubmissionPayloadDto interface.
 */
export function instanceOfUpdateSubmissionPayloadDto(value: object): value is UpdateSubmissionPayloadDto {
    if (!('assignedHandlerId' in value) || value['assignedHandlerId'] === undefined) return false;
    if (!('originalCurrency' in value) || value['originalCurrency'] === undefined) return false;
    if (!('inceptionDate' in value) || value['inceptionDate'] === undefined) return false;
    if (!('expiryDate' in value) || value['expiryDate'] === undefined) return false;
    if (!('principalOccupation' in value) || value['principalOccupation'] === undefined) return false;
    if (!('mainRegionAndRiskTerritory' in value) || value['mainRegionAndRiskTerritory'] === undefined) return false;
    if (!('keyRiskLocation' in value) || value['keyRiskLocation'] === undefined) return false;
    if (!('subClass' in value) || value['subClass'] === undefined) return false;
    return true;
}

export function UpdateSubmissionPayloadDtoFromJSON(json: any): UpdateSubmissionPayloadDto {
    return UpdateSubmissionPayloadDtoFromJSONTyped(json, false);
}

export function UpdateSubmissionPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubmissionPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedHandlerId': json['assignedHandlerId'],
        'namedUnderwriterId': json['namedUnderwriterId'] == null ? undefined : json['namedUnderwriterId'],
        'originalCurrency': json['originalCurrency'],
        'inceptionDate': (new Date(json['inceptionDate'])),
        'expiryDate': (new Date(json['expiryDate'])),
        'principalOccupation': json['principalOccupation'],
        'mainRegionAndRiskTerritory': json['mainRegionAndRiskTerritory'],
        'keyRiskLocation': json['keyRiskLocation'],
        'subClass': json['subClass'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function UpdateSubmissionPayloadDtoToJSON(json: any): UpdateSubmissionPayloadDto {
    return UpdateSubmissionPayloadDtoToJSONTyped(json, false);
}

export function UpdateSubmissionPayloadDtoToJSONTyped(value?: UpdateSubmissionPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedHandlerId': value['assignedHandlerId'],
        'namedUnderwriterId': value['namedUnderwriterId'],
        'originalCurrency': value['originalCurrency'],
        'inceptionDate': ((value['inceptionDate']).toISOString()),
        'expiryDate': ((value['expiryDate']).toISOString()),
        'principalOccupation': value['principalOccupation'],
        'mainRegionAndRiskTerritory': value['mainRegionAndRiskTerritory'],
        'keyRiskLocation': value['keyRiskLocation'],
        'subClass': value['subClass'],
        'comment': value['comment'],
        'fileIds': value['fileIds'],
    };
}

